<template>
  <div class="applink container-fluid">
    <div class="row no-gutters">
      <div class="linkbox">
        <p>
          <span>Rhythm Readerは</span><span>ウェブサイト型の</span><span>アプリです。</span><br>
          <span>一切の登録、</span><span>ダウンロード不要で</span><span>すぐに利用できます。</span><br>
        </p>
        <div class="version-links">
          <router-link to="/app" class="version-link version-link--primary">日本語版はこちら</router-link>
          <a href="https://rhythm-calculator.colour-field.jp" class="version-link version-link--sub">English Version</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'applink'
}
</script>

<style scoped>
.applink{
  border-top: 1px #aaaaaa solid;
  border-bottom: 1px #aaaaaa solid;
  padding: 3rem 0 2rem;
  margin: 0;
}
.linkbox{
  margin: 0;
  padding: 0;
  text-align: center;
  width: 100%;
}
.linkbox span{
  display: inline-block;
}
.version-links{
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  margin-top: 1rem;
}


.version-link{
  color: inherit;
  text-decoration: none;
}

.version-link--primary{
  display: inline-block;
  margin: 0;
  padding: 0.5rem 2rem;
  text-align: center;
  border-radius: 2rem;
  border: 2px solid #233b67;
  background: #233b67;
  color: #ffffff;
  font-weight: 500;
  transition: all 0.2s ease;
}

.version-link--primary:hover{
  background: #1a2d4f;
  border-color: #1a2d4f;
}

.version-link--sub{
  display: inline-block;
  padding: 0.25rem 1.5rem;
  border-radius: 1.5rem;
  border: 1px solid #8898b8;
  font-size: 0.85rem;
  color: #4a5d82;
  transition: all 0.2s ease;
}

.version-link--sub:hover{
  border-color: #233b67;
  color: #233b67;
  background: #f5f7fa;
}
</style>
